<template>
    <div class="product__container row">
        <div
            class="product__box"
            :class="mainClass"
            v-for="product in products"
            :key="product.id"
        >
            <product-second-card :product="product"> </product-second-card>
        </div>

        <div
            class="nothing__found"
            v-if="products.length === 0"
            :key="'products no found'"
        >
            <img :src="nothingFound" alt="Nothing found" />

            <h4>
                Ничего не найдено!
            </h4>
        </div>
    </div>
</template>

<script>
import ProductSecondCard from "./ProductSecondCard";
import nothingFound from "../../../../assets/image/NothingFound.webp";

export default {
    components: { ProductSecondCard },

    props: {
        products: {
            type: Array,
            required: true
        },

        additionClass: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            mainClass: "col-6 col-md-4 col-lg-3 col-xl-2",
            nothingFound: nothingFound
        };
    },

    mounted() {
        if (!!this.additionClass) {
            this.mainClass = this.additionClass;
        }
    }
};
</script>

<style lang="scss" scoped>
.product__container {
    margin-right: 7px;
    margin-left: 7px;

    .product__box {
        padding-right: 7px;
        padding-left: 7px;
        margin-bottom: 15px;
    }

    h2 {
        padding-right: 7px;
        padding-left: 7px;
        margin-bottom: 15px;
        font-family: Acrom-Bold, sans-serif;
        width: 100%;
        font-size: 22px;
        line-height: 1.4;
        color: #363f4d;
    }

    .nothing__found {
        display: flex;
        width: 100%;
        flex-direction: column;
        align-items: center;

        img {
            margin: 50px 0;
            width: 75%;
            height: auto;
            max-width: 307px;
        }

        h4 {
            font-family: Acrom-Bold, sans-serif;
            color: #363f4d;
            font-family: 20px;
        }
    }
}
</style>
